const textInput = {};
export default textInput;
